import React, { lazy } from 'react';
const AnnouncementBox = lazy(() => import('app/app/components/announcement-box'));
const KpiPad = lazy(() => import('app/app/components/kpi-pad'));
const Embed = lazy(() => import('app/app/components/embed'));
const EmbedTilesComponent = lazy(() => import('app/app/components/embed-tiles'));
const TextComponent = lazy(() => import('app/app/components/text'));
const FolderMenu = lazy(() => import('app/app/components/folder-menu'));

export default function AppBuilderComponentWrapper({ props }: { props: any }) {
    if ('announcement-box' === props.component) return <AnnouncementBox props={props} />;
    if ('kpi-pad' === props.component) return <KpiPad props={props} />;
    if ('embed' === props.component) return <Embed props={props} />;
    if ('embed-tiles' === props.component) return <EmbedTilesComponent props={props} />;
    if ('text' === props.component) return <TextComponent props={props} />;
    if ('folder-menu' === props.component) return <FolderMenu props={props} />;

    return <>{'Component not found'}</>;
}
